import { type Breakpoint } from '@divi/types';

export const defaultBreakpoints: Breakpoint.Item[] = [
  {
    enable: true,
    order: 50,
    name: 'desktop',
    baseDevice: true,
    label: 'Desktop',
  },
  {
    enable: true,
    maxWidth: {
      value: '980px',
      default: 980,
    },
    order: 30,
    name: 'tablet',
    label: 'Tablet',
  },
  {
    enable: true,
    maxWidth: {
      value: '767px',
      default: 767,
    },
    order: 10,
    name: 'phone',
    label: 'Phone',
  },
];

export const getEnabledBreakpoints = (): Breakpoint.Item[] => {
  if (window?.diviBreakpointData?.enabledBreakpoints) {
    return window?.diviBreakpointData?.enabledBreakpoints;
  }

  return defaultBreakpoints;
};
